export function isUnitSpec(spec) {
  return !!spec['mark'];
}